import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bafba4ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "niceWordsPage" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wave" }, null, -1))
const _hoisted_3 = { class: "nicewords" }
const _hoisted_4 = { class: "nicewordsWrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "niceWord" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordBy" }, "MIGUEL, SIERON - RISE ABOVE YOUR BODY"),
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordText" }, "Yasmine luistert naar wat je als persoon of bedrijf wilt, samen met haar alle puzzelstukjes samen leggen om tot een mooi geheel te komen verliep heel vlot en fantastisch. Ze hielp mij met de branding (naam, logo en extra's) in kader van de toekomstige opstart van mijn eigen bedrijf, ik ben enorm tevreden van het eindresultaat! Kortom, zoek je een heel gepassioneerde en creatieve grafische ontwerpster? Yasmine is your person!")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "niceWord" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordBy" }, "THOMAS, VR GAMES AT HOME"),
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordText" }, "Samenwerken met Carte Confituur was een echt plezier. Yasmine verzorgt alles tot in de puntjes, is zeer gedreven, correct en uitermate behulpzaam. Samen kwamen we tot een perfect resultaat.")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "niceWord" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordBy" }, "HANNAH & KYLE"),
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordText" }, "Yasmine maakte een creatieve vertaling van ons idee tot een fantastisch mooi ontwerp voor onze huwelijksuitnodiging! Zeer fijne samenwerking en communicatie.")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "niceWord" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordBy" }, "ANJA & ARNAUD"),
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordText" }, "Zeer tevreden! Goeie samenwerking met een prachtig resultaat.")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "niceWord" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordBy" }, "STEFFI, ALLUR BY STEFFI"),
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordText" }, "Heel tevreden over de professionele aanpak, snelle feedback en meehelpen denken naar de beste oplossing. Ik kan Carte Confituur enkel en alleen maar aanraden.")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "niceWord" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordBy" }, "MAGALI & YORICK"),
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordText" }, "Yasmine speelt perfect in op de wensen van de klant, ze denkt en zoekt mee naar het complete plaatje. Zéér aangename en professionele samenwerking. In de toekomst doen wij zeker terug beroep op haar werk!")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "niceWord" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordBy" }, "TOMAS, FULL ON"),
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordText" }, "Wij willen Yasmine echt nogmaals bedanken voor de prachtige creaties dat ze ons heeft bezorgd. We waren echt onder de indruk van haar werk en de snelheid waarmee we bij haar terecht konden!")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "niceWord" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordBy" }, "CHRISTIAAN, BUSINESS BEER"),
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordText" }, "Professioneel design, was goed bereikbaar en snelle oplevering.")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "niceWord" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordBy" }, "KATRIJN & KERIM, OUDERS VAN RENEE"),
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordText" }, "We willen Yasmine heel graag nog eens bedanken voor haar ontwerpen en het prachtige eindresultaat! Wie de kaartjes en/of doopsuiker gezien heeft is laaiend enthousiast!")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "niceWord" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordBy" }, "JELLE & SARAH, OUDERS VAN ESTHER"),
  /*#__PURE__*/_createElementVNode("div", { class: "niceWordText" }, "Yasmine heeft ons voor het geboortekaartje van onze dochter heel vlot en professioneel bediend. We zijn heel tevreden over het prachtige resultaat en de snelle service. Ze had snel inzicht in onze voorkeuren en haar ontwerp zat meteen in de juiste richting. Bovendien zorgde Yasmine ervoor dat het snel vooruit ging, waardoor het kaartje goed op tijd klaar was ondanks het feit dat onze dochter wat vroeger dan verwacht geboren werd. Kortom, zoek je iemand om vlot een mooi kaartje op jouw maat en volgens jouw wensen te ontwerpen, dan zit je bij Yasmine aan het juiste adres!")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wave inverted" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_swiper, {
          modules: _ctx.modules,
          "slides-per-view": 1,
          centeredSlides: true,
          loop: true,
          autoplay: {
              delay: 7000,
              disableOnInteraction: false,
            },
          navigation: true,
          pagination: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modules"])
      ])
    ]),
    _hoisted_15
  ]))
}